<template>
  <div class="page-container content-430">
    <div class="search-block">
      <Form
        ref="searchForm"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">

          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :clearable="true"
              @on-change="getTermChange"
              @getSelectTermName="getTermName"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="formInline.procSts"
              placeholder="执行状态"
              class="search-select-430"
            >
              <Option
                v-for="item in procStsList"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <Button
            type="primary"
            style="margin-right: 16px"
            @click="handleSearch"
          >查询</Button>
          <Button @click="handleReset">重置</Button>
        </Row>
      </Form>
    </div>
    <div
      class="action-wrap flex justify-content_end"
      style="margin-top:8px;margin-bottom: 8px"
    >
      <Button
        class="btn-download"
        style="margin-left: 16px"
        type="primary"
        @click="handleAddAdjust"
      >新建</Button>
    </div>
    <div class="table-main">
      <Table border :columns="tableColumn" :data="tableData" :loading="tableLoading">

        <template slot="termName">
          <span>{{ termName }}</span>
        </template>
        <template slot="procSts" slot-scope="{ row }">
          <div class="prosts-span" :class="proStsColorObj[row.procSts]">{{ proStsObj[row.procSts] }}</div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span class="click-btn-430" @click="handleOpenDetails(row)">详情</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page class="page-right" :total="pageInfo.total" show-sizer show-elevator show-total :current="pageInfo.pageNum" :page-size-opts="pageSizeOpts" @on-change="handlePageChange" @on-page-size-change="handlePageSize"></Page>
    </div>
    <AdjustDetails ref="adjustDetails" @refreshData="getRecordList"></AdjustDetails>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import AdjustDetails from './components/AdjustDetails';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { changeDictionaries } from '@/utils/dictionary.js';
export default {
  components: {
    CascaderYearTerms,
    AdjustDetails
  },
  data() {
    return {
      procStsList: [
        {
          label: '执行中',
          value: '0',
          bg: 'pass-status-430'
        },
        {
          label: '执行完成',
          value: '1',
          bg: 'normal-status-430'
        }
      ], // 执行状态 0-执行中 1-完成

      formInline: {
        procSts: '',
        termCode: '',
        yearCode: ''
      },
      searchData: {},
      termName: '',
      tableColumn: [
        {
          title: '区域/单位名称',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '学期',
          slot: 'termName',
          minWidth: 200
        },
        {
          title: '状态',
          slot: 'procSts',
          minWidth: 200
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 200
        },
        {
          title: '创建人',
          key: 'creatorName',
          minWidth: 200
        },
        {
          title: '操作',
          slot: 'action',
          minWidth: 200
        }
      ],
      tableData: [],
      tableLoading: false,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      pageSizeOpts: [10, 20, 50, 100],
      firstGetTerm: true
    };
  },
  computed: {
    ...mapState(['userInfo']),
    proStsObj() {
      return changeDictionaries(this.procStsList);
    },
    proStsColorObj() {
      return changeDictionaries(this.procStsList, 'bg');
    }
  },
  methods: {
    async getTermChange(e) {
      if (e && e.length === 2) {
        this.formInline.yearCode = e[0];
        this.formInline.termCode = e[1];
      } else {
        this.formInline.yearCode = '';
        this.formInline.termCode = '';
      }
      if (this.firstGetTerm) {
        this.handleSearch();
        this.firstGetTerm = false;
      }
    },
    getTermName(name) {
      this.termName = name;
    },
    // 查询
    handleSearch() {
      this.searchData = {};
      this.pageInfo.pageNum = 1;
      Object.keys(this.formInline).forEach(item => {
        if (this.formInline[item]) {
          this.searchData[item] = this.formInline[item];
        }
      });
      this.getRecordList();
    },
    // 重置
    handleReset() {
      const yearTerm = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault();
      this.formInline.yearCode = yearTerm[0];
      this.formInline.termCode = yearTerm[1];
      this.formInline.procSts = '';
      this.handleSearch();
    },
    // 获取调课记录列表
    async getRecordList() {
      this.tableLoading = true;
      try {
        const res = await courseSchedulCenter.getAdjustmentRecPageApi({ ...this.searchData, pageNo: this.pageInfo.pageNum, pageSize: this.pageInfo.pageSize });
        if (res.status === 200) {
          this.tableData = res.message.list;
          this.pageInfo.total = +res.message.total;
        }
      } finally {
        this.tableLoading = false;
      }
    },
    handlePageChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getRecordList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getRecordList();
    },
    handleAddAdjust() {
      this.$router.push({
        name: 'basicInfoCenter_opeManage_classTimeAdjust_classTimeAdjustAdd'
      });
    },
    handleOpenDetails({ id }) {
      this.$refs.adjustDetails.openModal(id);
    }
  }
};
</script>
<style lang='scss' scoped>
.prosts-span{
  position: relative;
  padding-left: 20px;
  // color: #444444;
  // font-size: 16px;
  // font-family: PingFangSC-Semibold, PingFang SC;
  line-height: 16px;
  &::before{
    content: ' ';
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    left: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}
.prosts-span-ing{
  &::before{
    background: rgb(149, 242, 4);
  }
}
.prosts-span-success{
  &::before{
    background: #488ffa;
  }
}
</style>
